import type { Questionnaire } from '@medplum/fhirtypes'
import {
  getComputationAnswerOptions,
  getComputationQuestionnaireItem,
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

const WORD_RECALL_ANSWER_OPTIONS = getComputationAnswerOptions([
  { code: 'yes', score: 1 },
  { code: 'no', score: 0 },
])

const CLOCK_DRAWING_ANSWER_OPTIONS = getComputationAnswerOptions([
  { code: 'normal', score: 2 },
  { code: 'abnormal', score: 0 },
])

export const miniCogQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/mini-cog',
  title: 'Mini-Cog',
  name: 'Mini-Cog',
  status: 'active',
  subjectType: ['Patient'],
  copyright: 'Mini-Cog© S. Borson. All rights reserved.',
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://mini-cog.com/wp-content/uploads/2022/04/Standardized-English-Mini-Cog-1-19-16-EN_v1-low-1-2.pdf',
        },
      ],
    },
    {
      linkId: '/word-list-version',
      type: 'choice',
      text: 'Word List Version',
      answerOption: [
        {
          valueCoding: {
            code: '1',
            display: 'Version 1: Banana, Sunrise, Chair',
          },
        },
        {
          valueCoding: {
            code: '2',
            display: 'Version 2: Leader, Season, Table',
          },
        },
        {
          valueCoding: {
            code: '3',
            display: 'Version 3: Village, Kitchen, Baby',
          },
        },
        {
          valueCoding: {
            code: '4',
            display: 'Version 4: River, Nation, Finger',
          },
        },
        {
          valueCoding: {
            code: '5',
            display: 'Version 5: Captain, Garden, Picture',
          },
        },
        {
          valueCoding: {
            code: '6',
            display: 'Version 6: Daughter, Heaven, Mountain',
          },
        },
      ],
    },
    {
      linkId: '/word-1-recalled',
      type: 'choice',
      text: 'Word 1 Recalled',
      answerOption: WORD_RECALL_ANSWER_OPTIONS,
    },
    {
      linkId: '/word-2-recalled',
      type: 'choice',
      text: 'Word 2 Recalled',
      answerOption: WORD_RECALL_ANSWER_OPTIONS,
    },
    {
      linkId: '/word-3-recalled',
      type: 'choice',
      text: 'Word 3 Recalled',
      answerOption: WORD_RECALL_ANSWER_OPTIONS,
    },
    {
      linkId: '/clock-drawing',
      type: 'choice',
      text: 'Clock Drawing',
      answerOption: CLOCK_DRAWING_ANSWER_OPTIONS,
    },
    getComputationQuestionnaireItem([
      { code: 'positive-screen', score: 2 },
      { code: 'negative-screen', score: 5 },
    ]),
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} as const satisfies Questionnaire
